import PropTypes from 'prop-types';
import { LoaderContext } from './LoaderContext';
import { initialStateLoader, loaderReducer } from './LoaderReducer';
import { useReducer } from 'react';

export const LoaderProvider = ({children}) => {
    const [ loader, loaderDispatch ] = useReducer(loaderReducer, initialStateLoader);
    return (
        <LoaderContext.Provider value={{
            loader,
            loaderDispatch
        }}>
            {children}
        </LoaderContext.Provider>
    )
}

LoaderProvider.propTypes = {
    children: PropTypes.node,
}